module.exports = __webpack_public_path__ + "img/card-contract-editor.bf19e25a.svg";